import { render, staticRenderFns } from "./MajorProject.vue?vue&type=template&id=633b3ca4&scoped=true&"
import script from "./MajorProject.vue?vue&type=script&lang=js&"
export * from "./MajorProject.vue?vue&type=script&lang=js&"
import style0 from "./MajorProject.vue?vue&type=style&index=0&id=633b3ca4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b3ca4",
  null
  
)

export default component.exports